import axios from 'axios';

const API_URL = process.env.REACT_APP_API_ENDPOINT;
let search = window.location.search;
let pathname = window.location.pathname;
let params = new URLSearchParams(search);
let token = params.get('token');

class AdministratorService{

    getAll(){
        return axios.get(API_URL+ "/administrator/list");
    }
    getFilter(query) {
        return axios.get(`${API_URL}/administrator/list-filter`, {
            params: {
                query: query,
            }
        });
    }
    confirm(data) {
        return axios.post(`${API_URL}/administrator/confirm`, data);
    }
    confirmToken() {
        return axios.get(`${API_URL}/administrator${pathname}`, {
            params: {
                token: token,
            }
        });
    }
}

export default new AdministratorService();